import { useRef, useEffect, type FC } from 'react'

import { audioManifest } from 'lib/assetLoader/manifests'
import { audioFormatPreferenceOrder } from 'lib/assetLoader'

const VOLUME = 0.2

interface Props {
  isPlaying: boolean
  currentVariantSlug: string
  onPlaySuccess?: () => void
  onPlayError?: () => void
}

export const AudioTags: FC<Props> = ({
  isPlaying,
  currentVariantSlug,
  onPlaySuccess,
  onPlayError,
}) => {
  const audioRefs = useRef<Record<string, HTMLAudioElement | null>>({})

  useEffect(() => {
    Object.keys(audioManifest).forEach((instanceSlug) => {
      const audioElement = audioRefs.current[instanceSlug]
      if (!audioElement) return

      const shouldPlay = instanceSlug === currentVariantSlug && isPlaying

      if (shouldPlay) {
        audioElement.volume = VOLUME
        audioElement.play().then(onPlaySuccess).catch(onPlayError) // e.g. user hasn't interacted with page yet
      } else {
        audioElement.pause()
      }
    })
  }, [isPlaying, currentVariantSlug, onPlaySuccess, onPlayError])

  return (
    <>
      {Object.values(audioManifest).map((audioInstance, index) => {
        const instanceSlug = Object.keys(audioManifest)[index]

        return (
          <audio
            key={instanceSlug}
            ref={(el) => {
              if (el) el.volume = VOLUME

              audioRefs.current[instanceSlug] = el
            }}
            loop
            style={{ display: 'none' }}
          >
            {audioFormatPreferenceOrder.map((format) => (
              <source
                key={format.fileType}
                src={audioInstance.getUrl(format.fileType)}
                type={format.mimeType}
              />
            ))}
          </audio>
        )
      })}
    </>
  )
}
